var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMidShift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.12 39.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#303030;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "midshift") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "midshift",
    className: "cls-1",
    d: "M10.41,7.87,8.25,5.71a1.91,1.91,0,0,0-2.7,2.7l2.16,2.15a1.9,1.9,0,0,0,2.69,0,0,0,0,0,0,0,0A1.9,1.9,0,0,0,10.41,7.87Zm0,20.58h0a1.92,1.92,0,0,0-2.7,0L5.55,30.6a1.91,1.91,0,1,0,2.7,2.7l2.15-2.16A1.9,1.9,0,0,0,10.42,28.45Zm8.69,3.69a2,2,0,0,0-2,1.91v3a2,2,0,0,0,4,0V34.05A2,2,0,0,0,19.11,32.14ZM19.11,0a2,2,0,0,0-2,1.9V5a2,2,0,0,0,4,0v-3A2,2,0,0,0,19.11,0Zm7.14,12.6a9.76,9.76,0,1,0,2.87,6.9A9.78,9.78,0,0,0,26.25,12.6ZM24.69,24.81A7.31,7.31,0,0,1,17,26.57a.32.32,0,0,1-.18-.18A.29.29,0,0,1,17,26a6.66,6.66,0,0,0,2.66-1.66,6.94,6.94,0,0,0,0-9.74A6.7,6.7,0,0,0,17.11,13a.3.3,0,0,1-.2-.29.3.3,0,0,1,.2-.28,7.34,7.34,0,0,1,7.6,1.83A7.55,7.55,0,0,1,24.69,24.81ZM6.2,19.49a2,2,0,0,0-1.71-2H1.75a2,2,0,0,0-1.75,2,2,2,0,0,0,1.67,2H4.49a2,2,0,0,0,1.71-2Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidShift);
export default __webpack_public_path__ + "static/media/midShift.cf05b394.svg";
export { ForwardRef as ReactComponent };